import { render, staticRenderFns } from "./ImagenZoom.vue?vue&type=template&id=4df63e9a&"
import script from "./ImagenZoom.vue?vue&type=script&lang=js&"
export * from "./ImagenZoom.vue?vue&type=script&lang=js&"
import style0 from "./ImagenZoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/development/pet-manager/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
